"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListErrorReportsResponseSchema = exports.ListErrorReportsQuerySchema = exports.ErrorReportResponseSchema = exports.ErrorReportFields = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const common_1 = require("../common");
exports.ErrorReportFields = {
    ...core_1.ModelMetaFields,
    ...common_1.ErrorFields,
};
exports.ErrorReportResponseSchema = (0, core_1.StrictObject)({
    ...exports.ErrorReportFields,
    ...core_1.ModelMetaFields,
}, { title: "Error Report", description: "Report relating to a error" });
exports.ListErrorReportsQuerySchema = (0, core_1.createSortedPaginationQuerySchema)({
    userId: typebox_1.Type.Optional(core_1.IdSchema),
    teamId: typebox_1.Type.Optional(core_1.IdSchema),
    campaignId: typebox_1.Type.Optional(core_1.IdSchema),
    ...core_1.DateFilterFields,
    type: (0, core_1.OptionalArrayQueryType)(common_1.ErrorTypeSchema),
    severity: typebox_1.Type.Optional(common_1.ErrorSeveritySchema),
}, core_1.TimestampSort);
exports.ListErrorReportsResponseSchema = (0, core_1.createSortedListResponseSchema)(exports.ErrorReportResponseSchema, core_1.TimestampSort);
